import { atom } from 'jotai'
import type { FontSelection } from './types'

export const fontPickerOpenAtom = atom(false)

/**
 * Holds the resolve/reject pair for the current open() promise.
 * When a font is selected, resolve is called. When closed without selection, resolve(undefined).
 * If a second caller opens while a previous promise is pending, the previous is rejected.
 */
export const fontPickerPromiseAtom = atom<
	{
		resolve: (value: FontSelection | undefined) => void
		reject: (reason?: unknown) => void
	} | null
>(null)

// Internal UI state — persists across open/close cycles
export const fontPickerSelectedFontIdAtom = atom<string | null>(null)
